export const environment = {
  domain: "https://api.nerdof.com/api",
  //  domain: "https://tula-api-sandbox.deknerd.com/api",
  // domain: "http://192.168.1.142/api",
  // domain: "http://localhost/api",
  // serverName: "TEST",
  // PROD ------------------------------------------
  // domain: 'https://api.nerdof.com/api',
  // serverName: 'TULA',
  // domainFirebase: 'https://us-central1-deknerd-556e6.cloudfunctions.net'
  // TEST ------------------------------------------
  // domain: "http://192.168.1.141/api",
  // serverName: "TEST",
  // domainFirebase: 'http://localhost:5005/deknerd-556e6/us-central1',
  // LOCAL -----------------------------------------
  // domain: 'http://localhost/api',
  serverName: 'TULA',
  domainFirebase: 'http://localhost:5005/deknerd-556e6/us-central1'
};
